
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as poc6zQm2o2slRZiCs4fzLsW5ebRfcFROJeZ1OfMPWN6IHwMeta } from "/vercel/path0/apps/front/src/pages/poc.vue?macro=true";
import { default as joinVSqqDzo_poBycInHAbhtCNemwbsi3Tku5am7TKVOi1MMeta } from "/vercel/path0/apps/front/src/pages/join.vue?macro=true";
import { default as testAiXAzdvT_450jpM0G6VmV6zF0vrps06iSL35Zjbk_45wwXYMeta } from "/vercel/path0/apps/front/src/pages/test.vue?macro=true";
import { default as index7pBMIiYd9qmI_ffWo_45Igh8_45j59hi7tAenlCvmklXs5IMeta } from "/vercel/path0/apps/front/src/pages/index.vue?macro=true";
import { default as indexV2eFNyP5zOfvmLPV5AwTuYORhqhf8o0aaQaoiPSzbMrJcMeta } from "/vercel/path0/apps/front/src/pages/indexV2.vue?macro=true";
import { default as about_45usQryGvm_454MfYPHCWInhG8QB9_45C6Lc8Fwm9zP5EnxqupoMeta } from "/vercel/path0/apps/front/src/pages/about-us.vue?macro=true";
import { default as discoverQ_454aac7Rzv1IIFp_45iubxYhByoOSsSOF_45Kz8Nnolcv3wMeta } from "/vercel/path0/apps/front/src/pages/discover.vue?macro=true";
import { default as campaignsrWSRdTOUYCJ2cnuEBvaBlJMP9HVNDZlI43RWSPeNGcYMeta } from "/vercel/path0/apps/front/src/pages/campaigns.vue?macro=true";
import { default as contact_45usx5PnpTBV3BmmKxHWMWXLETpU108iFwa8E_45iVAVqhHVUMeta } from "/vercel/path0/apps/front/src/pages/contact-us.vue?macro=true";
import { default as _91id_93zfHma_45rA47FvveYu0AWuXQoL6L2wlu8rYIe_bfKmuCoMeta } from "/vercel/path0/apps/front/src/pages/video/[id].vue?macro=true";
import { default as exhibitionsZbCzbsYcf_45lzHagpYhxCAvm9Pe4ImVU6pJ_45KfkYWdK0Meta } from "/vercel/path0/apps/front/src/pages/exhibitions.vue?macro=true";
import { default as topics_45index4Qv51TJZljqf2HR6WlhDACj9U7cTkT_45RuMsOvI5eMfUMeta } from "/vercel/path0/apps/front/src/pages/topics-index.vue?macro=true";
import { default as index4izVqXGhAxMbR5dLRUw9wDYFEZxY_IzYFe77rIStPJ8Meta } from "/vercel/path0/apps/front/src/pages/beliefs/index.vue?macro=true";
import { default as index8QhBd0nelcEQScGoydSYFeOEGc25no4MJXFLizAQqE8Meta } from "/vercel/path0/apps/front/src/pages/khalifa/index.vue?macro=true";
import { default as index2gHNHMvmB3xeOp3RnLDRSbLAuEAbQueNAFwkysXjKJ8Meta } from "/vercel/path0/apps/front/src/pages/stopww3/index.vue?macro=true";
import { default as indexv3NVD3lBHb3Zdp1r3q9_Z7gXJc7kKL988SR4lgKhVgkMeta } from "/vercel/path0/apps/front/src/pages/articles/index.vue?macro=true";
import { default as _91slug_93HLvG2KTJjS6ca_45Djrc97cUi6dq2AJRm_45HP8yAvb202YMeta } from "/vercel/path0/apps/front/src/pages/beliefs/[slug].vue?macro=true";
import { default as search_45resultsiaQm9uHmNmVnoCt0I3Pq6xu5IboionX6RnZIGKqwnX8Meta } from "/vercel/path0/apps/front/src/pages/search-results.vue?macro=true";
import { default as use_45of_45cookiesF85SPZ22FGOcouQ9SBVNyxT33NygvTlYrVPoWrYU1j8Meta } from "/vercel/path0/apps/front/src/pages/use-of-cookies.vue?macro=true";
import { default as _91slug_93jBqGA6U_X92rnsMqyMWA_45heXX_45rsEsTKW5MR9fXFuY4Meta } from "/vercel/path0/apps/front/src/pages/articles/[slug].vue?macro=true";
import { default as export_45requestsGPtqeRiius0sCpcKG3G9tVaNOGocESklXtdzFx4gpfQMeta } from "/vercel/path0/apps/front/src/pages/export-requests.vue?macro=true";
import { default as terms_45of_45servicebFr__45gRFm40OF5S_45xEQ_MbbpRPTVpp0d9FmrydOeWKwMeta } from "/vercel/path0/apps/front/src/pages/terms-of-service.vue?macro=true";
import { default as nuestros_45clientesMR3A0IHn7jMETlKWYhLJBbXy1FaLcW2dse8cI5CT0HYMeta } from "/vercel/path0/apps/front/src/pages/nuestros-clientes.vue?macro=true";
import { default as index1rwwK_hAkY6UDnrNTOCsEm5NI0P9rZercR8z2JyX8k8Meta } from "/vercel/path0/apps/front/src/pages/elevenpoints/index.vue?macro=true";
import { default as _91slug_93RfdeM1M3t57tAucgZrQwsXyquBXrRqDgpAKyoxI4BgAMeta } from "/vercel/path0/apps/front/src/pages/elevenpoints/[slug].vue?macro=true";
import { default as introductionYUAh244D8IcgrbfTgEmGTOzXVb9lTdRW9IgkSAUBIdwMeta } from "/vercel/path0/apps/front/src/pages/stopww3/introduction.vue?macro=true";
import { default as the_45campaignrQaVFKoecEil7ONZgM5ZWa_FSS8_YgeGcURu8XV6QBcMeta } from "/vercel/path0/apps/front/src/pages/stopww3/the-campaign.vue?macro=true";
import { default as the_45prophecyPcJO09Qbe7Ev9WJ33Y8v01FkTZg_hRimeHO0autuRA8Meta } from "/vercel/path0/apps/front/src/pages/stopww3/the-prophecy.vue?macro=true";
import { default as submit_45your_45questionpAx5d_45s_scYlFsGxiKso3wuy8hn2Ix6Wv7SuPkiUpKUMeta } from "/vercel/path0/apps/front/src/pages/submit-your-question.vue?macro=true";
import { default as the_45messiah_45has_45comePG2ehQQFBAvxRBhLvQB8jbSCsWEZXOxu5k_2otemJEcMeta } from "/vercel/path0/apps/front/src/pages/the-messiah-has-come.vue?macro=true";
import { default as the_45critical_45need_45for_45peace0amahZ64MLiQ_OYu_45qxEq0U5qvdQllBoq_45JXiXsmJmMMeta } from "/vercel/path0/apps/front/src/pages/stopww3/the-critical-need-for-peace.vue?macro=true";
export default [
  {
    name: "poc",
    path: "/poc",
    component: () => import("/vercel/path0/apps/front/src/pages/poc.vue")
  },
  {
    name: "join",
    path: "/join",
    component: () => import("/vercel/path0/apps/front/src/pages/join.vue")
  },
  {
    name: "test",
    path: "/test",
    meta: testAiXAzdvT_450jpM0G6VmV6zF0vrps06iSL35Zjbk_45wwXYMeta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/test.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index7pBMIiYd9qmI_ffWo_45Igh8_45j59hi7tAenlCvmklXs5IMeta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/index.vue")
  },
  {
    name: "indexV2",
    path: "/indexV2",
    component: () => import("/vercel/path0/apps/front/src/pages/indexV2.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/vercel/path0/apps/front/src/pages/about-us.vue")
  },
  {
    name: "discover",
    path: "/discover",
    meta: discoverQ_454aac7Rzv1IIFp_45iubxYhByoOSsSOF_45Kz8Nnolcv3wMeta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/discover.vue")
  },
  {
    name: "campaigns",
    path: "/campaigns",
    component: () => import("/vercel/path0/apps/front/src/pages/campaigns.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/vercel/path0/apps/front/src/pages/contact-us.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/vercel/path0/apps/front/src/pages/video/[id].vue")
  },
  {
    name: "exhibitions",
    path: "/exhibitions",
    component: () => import("/vercel/path0/apps/front/src/pages/exhibitions.vue")
  },
  {
    name: "topics-index",
    path: "/topics-index",
    meta: topics_45index4Qv51TJZljqf2HR6WlhDACj9U7cTkT_45RuMsOvI5eMfUMeta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/topics-index.vue")
  },
  {
    name: "beliefs",
    path: "/beliefs",
    component: () => import("/vercel/path0/apps/front/src/pages/beliefs/index.vue")
  },
  {
    name: "khalifa",
    path: "/khalifa",
    meta: index8QhBd0nelcEQScGoydSYFeOEGc25no4MJXFLizAQqE8Meta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/khalifa/index.vue")
  },
  {
    name: "stopww3",
    path: "/stopww3",
    meta: index2gHNHMvmB3xeOp3RnLDRSbLAuEAbQueNAFwkysXjKJ8Meta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/stopww3/index.vue")
  },
  {
    name: "articles",
    path: "/articles",
    meta: indexv3NVD3lBHb3Zdp1r3q9_Z7gXJc7kKL988SR4lgKhVgkMeta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/articles/index.vue")
  },
  {
    name: "beliefs-slug",
    path: "/beliefs/:slug()",
    meta: _91slug_93HLvG2KTJjS6ca_45Djrc97cUi6dq2AJRm_45HP8yAvb202YMeta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/beliefs/[slug].vue")
  },
  {
    name: "search-results",
    path: "/search-results",
    component: () => import("/vercel/path0/apps/front/src/pages/search-results.vue")
  },
  {
    name: "use-of-cookies",
    path: "/use-of-cookies",
    component: () => import("/vercel/path0/apps/front/src/pages/use-of-cookies.vue")
  },
  {
    name: "articles-slug",
    path: "/articles/:slug()",
    meta: _91slug_93jBqGA6U_X92rnsMqyMWA_45heXX_45rsEsTKW5MR9fXFuY4Meta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/articles/[slug].vue")
  },
  {
    name: "export-requests",
    path: "/export-requests",
    component: () => import("/vercel/path0/apps/front/src/pages/export-requests.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    component: () => import("/vercel/path0/apps/front/src/pages/terms-of-service.vue")
  },
  {
    name: "nuestros-clientes",
    path: "/nuestros-clientes",
    component: () => import("/vercel/path0/apps/front/src/pages/nuestros-clientes.vue")
  },
  {
    name: "elevenpoints",
    path: "/elevenpoints",
    meta: index1rwwK_hAkY6UDnrNTOCsEm5NI0P9rZercR8z2JyX8k8Meta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/elevenpoints/index.vue")
  },
  {
    name: "elevenpoints-slug",
    path: "/elevenpoints/:slug()",
    meta: _91slug_93RfdeM1M3t57tAucgZrQwsXyquBXrRqDgpAKyoxI4BgAMeta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/elevenpoints/[slug].vue")
  },
  {
    name: "stopww3-introduction",
    path: "/stopww3/introduction",
    meta: introductionYUAh244D8IcgrbfTgEmGTOzXVb9lTdRW9IgkSAUBIdwMeta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/stopww3/introduction.vue")
  },
  {
    name: "stopww3-the-campaign",
    path: "/stopww3/the-campaign",
    component: () => import("/vercel/path0/apps/front/src/pages/stopww3/the-campaign.vue")
  },
  {
    name: "stopww3-the-prophecy",
    path: "/stopww3/the-prophecy",
    meta: the_45prophecyPcJO09Qbe7Ev9WJ33Y8v01FkTZg_hRimeHO0autuRA8Meta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/stopww3/the-prophecy.vue")
  },
  {
    name: "submit-your-question",
    path: "/submit-your-question",
    component: () => import("/vercel/path0/apps/front/src/pages/submit-your-question.vue")
  },
  {
    name: "the-messiah-has-come",
    path: "/the-messiah-has-come",
    component: () => import("/vercel/path0/apps/front/src/pages/the-messiah-has-come.vue")
  },
  {
    name: "stopww3-the-critical-need-for-peace",
    path: "/stopww3/the-critical-need-for-peace",
    meta: the_45critical_45need_45for_45peace0amahZ64MLiQ_OYu_45qxEq0U5qvdQllBoq_45JXiXsmJmMMeta || {},
    component: () => import("/vercel/path0/apps/front/src/pages/stopww3/the-critical-need-for-peace.vue")
  }
]